import { type DetailedHTMLProps, type InputHTMLAttributes, type ReactNode, useId } from 'react';

export const OpenFormCheckbox = ({
  indeterminate,
  label,
  onChange,
  readOnly,
  ...props
}: {
  indeterminate?: boolean;
  label?: ReactNode;
} & Omit<DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>, 'id' | 'ref' | 'type'>) => {
  const id = useId();
  return (
    <div className="of-openform-checkbox">
      <input
        {...props}
        id={id}
        onChange={onChange}
        readOnly={!onChange || readOnly}
        ref={el => {
          el && (el.indeterminate = !!indeterminate);
        }}
        type="checkbox"
      />
      {label ? <label htmlFor={id}>{label}</label> : null}
    </div>
  );
};
